import React from 'react';
import PropTypes from "prop-types";
import {
  Card,
  ListGroup,
  ListGroupItem,
  Row,
  Col
} from "react-bootstrap";

import _ from 'lodash';

const UserAccountDetails = ({ title, user, readOnly }) => {
  const fieldValue = path => String(_.get(user, path, '') || '').trim();

  return (
    <Card className="mb-4">
      <Card.Header className="border-bottom">
        <h6 className="m-0">{title}</h6>
      </Card.Header>
      <ListGroup variant="flush">
        <ListGroupItem className="p-3">
          <Row>
            <Col>
              <form >
                <Row>
                  {/* First Name */}
                  <Col md="5" className="form-group">
                    <label htmlFor="feFirstName">First Name</label>
                    <input
                      id="feFirstName"
                      placeholder="First Name"
                      value={fieldValue('details.firstname')}
                      readOnly
                    />
                  </Col>
                  {/* Last Name */}
                  <Col md="5" className="form-group">
                    <label htmlFor="feLastName">Last Name</label>
                    <input
                      id="feLastName"
                      placeholder="Last Name"
                      value={fieldValue('details.lastname')}
                      readOnly
                    />
                  </Col>
                  <Col md="2" className="form-group">
                    <label htmlFor="gender">Gender</label>
                    <input
                      id="gender"
                      placeholder="Gender"
                      value={fieldValue('details.gender')}
                      readOnly
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="4" className="form-group">
                    <label htmlFor="mobile">Mobile</label>
                    <input
                      id="mobile"
                      placeholder="09123456789"
                      value={fieldValue('details.mobile')}
                      readOnly
                    />
                  </Col>
                  <Col md="4" className="form-group">
                    <label htmlFor="country">Country</label>
                    <input
                      id="country"
                      placeholder="Country"
                      value={fieldValue('details.country')}
                      readOnly
                    />
                  </Col>
                  <Col md="4" className="form-group">
                    <label htmlFor="city">City</label>
                    <input
                      id="city"
                      placeholder="City"
                      value={fieldValue('details.city')}
                      readOnly
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md="8" className="form-group">
                    <label htmlFor="address">Address</label>
                    <input
                      id="address"
                      placeholder="Babaie Hway"
                      value={fieldValue('details.address')}
                      readOnly
                    />
                  </Col>
                  <Col md="4" className="form-group">
                    <label htmlFor="postalCode">Postal Code</label>
                    <input
                      id="postalCode"
                      placeholder="1234567890"
                      value={fieldValue('details.postalCode')}
                      readOnly
                    />
                  </Col>
                </Row>
                {/* <Button theme="accent">Update Account</Button> */}
              </form>
            </Col>
          </Row>
        </ListGroupItem>
      </ListGroup>
    </Card>
  );
}

UserAccountDetails.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string,
  readOnly: PropTypes.bool
};

UserAccountDetails.defaultProps = {
  title: "User Profile",
  readOnly: true
};

export default UserAccountDetails;
